// planner-btn-trigger

var FX = ( function( FX, $ ) {

	$( () => {
		FX.PlannerButtonTriggger.init()
	})

	FX.PlannerButtonTriggger = {
		$trigger: null,
		$tab: null,
		$body: null,
		$offset: null,
		init() {
			this.$trigger = $('.planner-btn-trigger');
			this.$tab = $('a[href="#tab3"]');
			this.$body = $('html, body');



			if ( this.$trigger.length && this.$tab.length ) {
				setTimeout(() => {

					this.calculateOffset();
					this.bindEvents()

				}, 500)
			}

        },
		bindEvents() {
			this.$trigger.on('click', this.handleClick.bind(this))
	
		},
		calculateOffset() {
			setTimeout( () => {
				this.$offset = this.$tab.offset().top - $('#header').outerHeight();
				console.log(this.$tab.offset().top)
				console.log($('#header').outerHeight())
				console.log(this.$offset);
			}, 1000)
		},
		handleClick(e) {
			e.preventDefault();

			this.$tab.trigger('click');

			this.$body.animate({
				scrollTop: this.$offset
			}, 1000);

		}

	};

	return FX

} ( FX || {}, jQuery ) )